export default __webpack_public_path__ + "static/media/doodlersclub.e9636f65.jpg";